import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="testimonials-title">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            用户评价
          </span>
          <h2
            id="testimonials-title"
            className="mt-3 text-2xl md:text-4xl font-heading text-foreground-950"
          >
            漫友们的真实反馈
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            来自全国各地的漫画爱好者，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <article
              key={item.id}
              className="p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">忠实读者</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}